// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + ".js?v=2026-10-15T04-37-20.986Z";
};